import { $t } from '@/i18n';
import { addPathPrefix } from '@/utils/path';
import { FLOW_JOB_STATUS_META } from './wuji-flow/statusMeta';
export function getEmptyJobFromFlow({ flowId, flowGraph, name = flowId, creator = window.w.user.rtx, envId = window.w.env || 'dev', projectId = window.w.projectId, }) {
    return {
        creator,
        ctime: +new Date(),
        currentApprovers: '',
        envId,
        flowId,
        flowState: {},
        status: '',
        relatedUsers: '',
        id: '',
        message: '',
        mtime: +new Date(),
        projectId,
        jobTickId: '',
        jobParams: {},
        flowGraph,
        flowName: name || flowId,
        title: name || flowId,
        partialCtx: {},
    };
}
export function getFlowJobPageURL({ projectId = window.w.projectId, flowId, jobId = '', envId = window.w.env, branchId, // = envId === 'dev' && window.RUNTIME_CONFIGS.branch,  // 暂时不考虑填入默认值，避免奇怪问题
hashData = '', }) {
    const url = new URL(location.href);
    let envPart = envId;
    if (branchId && envPart === 'dev')
        envPart = `branch/${branchId}`;
    url.pathname = addPathPrefix(`/xy/app/${envPart}/${encodeURIComponent(projectId)}/wuji/workflow/flow/${encodeURIComponent(flowId)}`);
    url.search = '';
    url.searchParams.set('projectId', projectId);
    if (jobId)
        url.searchParams.set('jobId', jobId);
    if (hashData)
        url.hash = hashData;
    return url.toString();
}
/** 用 nodeId + startTickId 定位 detail block，返回其最后更新 tickId；找不到则为空串 */
export function getDetailBlockTickId(blocks, nodeId, startTickId) {
    const start = startTickId ?? '';
    const block = blocks?.find(item => item.nodeId === nodeId && (item.startTickId ?? '') === start);
    return block?.tickId ?? '';
}
/** 根据 startTickId 获取这个节点再次被执行之前的 tickId */
export function getNodeSuccessTickId(opts) {
    const { startTickId, flowState, nodeId } = opts;
    if (!flowState)
        return '';
    const startTickIds = flowState.$nodes?.[nodeId]?.startTickIds || [];
    // 找下一个 如果找不到就用最后的tickId
    const nextStartTick = (startTickId && startTickIds
        .find((_item, index, arr) => arr[index - 1] === startTickId)) || '';
    return nextStartTick || '';
}
export function createFakeStartDetailBlock() {
    return {
        ctime: +new Date(),
        nodeId: 'start',
        type: 'start',
        title: $t('k_7d8fd189'),
    };
}
export function isTerminalJobStatus(jobStatus) {
    return !!jobStatus && !!FLOW_JOB_STATUS_META[jobStatus]?.isTerminal;
}
